import { API_URL } from '@/config/url_config'
import {fetch} from './index'
// 获取编译结果
export let getCompileResult = (data) => {
  return new Promise((resolve, reject) => {
    let url = `${API_URL}/submit/submitCode/api`
    fetch('POST', url, data).then((data) => {
      console.log('data', data)
      resolve(data)
    }).catch(() => {
      resolve(null)
    })
  })
}


// WEBPACK FOOTER //
// ./src/api/getCompileResult.js